<template>
    <div>
        <a-row class="mt">
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>{{ $t('generic.Add') }}</span>
                </template>
                <img class="sbxs" src="../../../../assets/img/ss-add.png" width="22" height="22" @click="addCondition">
            </a-tooltip>
            <a-popconfirm
                    :title="$t('generic.AreyoudeleTask')"
                    @confirm="delCondition"
                    :okText="$t('generic.Yes')"
                    :cancelText="$t('generic.No')">
                <a-tooltip placement="topLeft" class="ml4">
                    <template slot="title">
                        <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../../../assets/img/ss-delete.png" width="22" height="22">
                </a-tooltip>
            </a-popconfirm>
            <a-row class="mt">
                <vxe-table
                        border
                        resizable
                        highlight-hover-row
                        size="mini"
                        ref="conditionRefs"
                        height="450"
                        :data="tableData">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="columnName" title="Column Name" minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dsName" title="Datasource"  minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="paramValue" title="Value"  minWidth="150"></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>
        <a-modal
                title="Add Condition"
                :visible="addConditionVis"
                width="45%"
                @cancel="() => (addConditionVis = !addConditionVis)"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="addSaveCondition">Save</a-button>
            </template>
            <a-form :form="addConditionForm">
                <a-form-item label="Data Source" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            @change="dataSourceChange"
                            v-decorator="[ 'dsName',{ rules: [{ required: true, message: $t('publicLang.Required') }] }]"
                    >
                        <a-select-option v-for="item in dataSourceLsit" :value="item.uid">{{item.dsName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Binding Filed" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[ 'rtSqlCondUid',{ rules: [{ required: true, message: $t('publicLang.Required') }] }]"
                    >
                        <a-select-option v-for="item in valueList" :value="item.rtSqlCondUid">{{item.paramValue}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Column Name" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            showSearch
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[ 'columnName',{ rules: [{ required: true, message: $t('publicLang.Required') }] }]"
                    >
                        <a-select-option v-for="item in columnLsit" :value="item">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props:{
            targetObj: {
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        data(){
            return{
                tableData:[],
                addConditionVis: false,
                addConditionForm: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                editConditionVal:{},
                columnLsit: [],
                dataSourceLsit:[],
                valueList: []
            }
        },
        created(){
            this.init()
        },
        watch:{
            targetObj(){
                this.init()
            }
        },
        methods:{
            init(){
                ajax.get(api.GENERICBEHAVIORCONDITION,{btnUid: this.targetObj.behrUid}).then(res=>{
                    this.tableData = res.data
                })
            },
            addCondition(){
                this.addConditionVis = true
                this.addConditionForm.resetFields();
                ajax.get(api.GENERICNAMEBEHAVIORCOLUMN,{gmcUid: this.targetObj.behaviorRepotHeaderUid}).then(res=>{
                    this.columnLsit = res.data
                })
                ajax.get(api.GENERICBEHAVIORDATASOURCE,{rtMasterUid: this.targetObj.rtMasterUid}).then(res=>{
                    this.dataSourceLsit = res.data
                })
            },
            addSaveCondition(){
                this.addConditionForm.validateFields((error, values)=>{
                    if(!error){
                        values.btnUid = this.targetObj.behrUid
                        ajax.post(api.GENERICBEHAVIORCONDITION,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.init()
                                this.addConditionVis = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
            delCondition(){
                let arr = this.$refs.conditionRefs.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.GENERICDELBEHAVIORCONDITION,params).then(res=>{
                        if(res.code == 200){
                            this.init()
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            },
            dataSourceChange(val){
                ajax.get(api.GENERICBEHAVIORVALUE,{geRtSqlUid: val}).then(res=>{
                    this.valueList = res.data
                })
            }
        }
    }
</script>